var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Wait"},[_c('div',{staticClass:"Con"},[_c('img',{attrs:{"src":require("../../../../static/img/logo_cover.png"),"width":"80%"}}),_vm._v(" "),_c('div',[_c('label',{staticClass:"AppText"},[_vm._v("您的申请正在审核中...")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487ea8c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/OnLineBook/components/Wait.vue
// module id = null
// module chunks = 